import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// React 19 + react-snap (Feb 2026 SEO lockdown).
// react-snap pre-renders public routes (/, /demo, /about, /exams/*, /blog, legal) at
// build time so search-engine crawlers and social-link previews see real text/markup
// instead of the empty SPA shell. When pre-rendered HTML is present in the DOM at
// boot, we hydrate it (attach event listeners) instead of re-rendering — otherwise
// React 19 would throw away the pre-rendered content and the SEO benefit is lost.
const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
